import { AuthUser } from '@app/account/account-api.model';
import { RecommendingItem } from './recommendations.model';
import { ResourcePrivacyLevel } from '@app/shared/models/core-api.model';

export const createEnhancedRecommendingItem = (
  item: RecommendingItem,
  authUser: AuthUser
): RecommendingItem => {
  let itemResourceId: number;
  // Data massaging to get unrelated items munged into a common property set
  // TODO: Code smells abound here. It should be reworked into something aromatic when we get better content unification on the client
  const {
    actions,
    actionsLabel,
    id,
    resourceId,
    resourceType,
    referenceType,
    targetId,
  } = item;

  // check is defined because ResourceIds of Q&As === 0. sigh.
  if (resourceId !== null && resourceId !== undefined) {
    itemResourceId = resourceId;
  } else if (id) {
    itemResourceId = id;
  } else if (targetId) {
    itemResourceId = targetId;
  }

  const itemResourceType = resourceType ? resourceType : referenceType;

  return {
    ...item,
    resourceType: itemResourceType,
    isOrgContent:
      !!item.organizationId &&
      Number(item.organizationId) === authUser.defaultOrgId,
    resourceId: itemResourceId,
    // We shouldn't need to default to null anywhere in ngx code, so this can be assumed is for ajs compatibility
    actions: actions ?? null,
    actionsLabel: actionsLabel ?? null,
  };
};


export const isUserPermittedToCreateTrackableLink = (
  enhancedItem: RecommendingItem,
  authUser: AuthUser,
  privacyId: ResourcePrivacyLevel,
  isPathways: boolean,
  useGranularContentPermissions: boolean
): boolean => {
  const trackableResourceTypes = ['Target', 'Pathway'];
  const { canManageTargets } = authUser;

  const canCreateTrackableLinksForTargets = useGranularContentPermissions
    ? authUser?.defaultOrgInfo?.permissions?.addOrganizationTarget ||
      authUser?.defaultOrgInfo?.permissions?.updateOrganizationTarget ||
      authUser?.defaultOrgInfo?.permissions?.deleteOrganizationTarget
    : canManageTargets;
    
  const canCreateTrackableLinksForPathways = useGranularContentPermissions
    ? authUser.defaultOrgInfo?.permissions?.addOrganizationPathways ||
      authUser.defaultOrgInfo?.permissions?.updateOrganizationPathways
    : authUser.defaultOrgInfo?.permissions?.managePathways;

  return (
    trackableResourceTypes.some((tr) => enhancedItem?.resourceType === tr) &&
    ((isPathways && canCreateTrackableLinksForPathways) ||
      (!isPathways && canCreateTrackableLinksForTargets && privacyId !== 0))
  );
};
